import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const rmaOverviewHeader: CSSResult = css`
  :host {
    display: block;
    margin-bottom: ${csSpacing.spacing08};
  }
`
